import { FC } from 'react';
import Box from 'yoda-ui/Box';
import DialogContent from 'yoda-ui/Dialogs/Dialog/DialogContent';
import { YodaSpacing } from 'yoda-ui/yodaTheme';

const DialogFormContent: FC = ({ children }) => (
  <DialogContent>
    <Box marginY={ YodaSpacing.large }>
      { children }
    </Box>
  </DialogContent>
);

export default DialogFormContent;
